export default {
  provisionAdjustments: {
    name: 'provisionAdjustments',
    fields: ['adjustmentId'],
  },
  adminBusinessUnitSettings: {
    name: 'adminBusinessUnitSettings',
    fields: ['businessUnit'],
  },
  adminCategoriesAndTags: {
    name: 'adminCategoriesAndTags',
    fields: ['tagName'],
  },
  adminClient: {
    name: 'adminClient',
    fields: ['clientId'],
  },
  adminCompanyCodes: {
    name: 'adminCompanyCodes',
    fields: ['companyCode'],
  },
  adminTaxAccounting: {
    name: 'adminTaxAccounting',
    fields: ['taxDescription'],
  },
  adminTaxBookingEntity: {
    name: 'adminTaxBookingEntity',
    fields: ['companyCode', 'tbeCompanyCode', 'tbeType'],
  },
  adminTaxEntries: {
    name: 'adminTaxEntries',
    fields: ['slAccount'],
  },
  adminTLSAccounts: {
    name: 'adminTLSAccounts',
    fields: ['account'],
  },
  adminLegalEntities: {
    name: 'adminLegalEntities',
    fields: ['legalEntity'],
  },
  adminTaxRates: {
    name: 'adminTaxRates',
    fields: ['countryTaxType'],
  },
  adminBookToTaxDifferences: {
    name: 'adminBookToTaxDifferences',
    fields: ['countryTaxType', 'exceptionAccount', 'exceptionBasis'],
  },
  adminUsersAndPrivileges: {
    name: 'adminUsersAndPrivileges',
    fields: ['sso'],
  },
  adminClientAdministrationConnections: {
    name: 'adminClientAdministrationConnections',
    fields: ['connName'],
  },
  adminClientAdministrationBookToTaxCodes: {
    name: 'adminClientAdministrationConnections',
    fields: ['tagCode', 'countryTaxType'],
  },
  adminClientAdministrationCurrency: {
    name: 'adminClientAdministrationCurrency',
    fields: ['currencyCode'],
  },
  adminClientAdministrationCountry: {
    name: 'adminClientAdministrationCountry',
    fields: ['countryCode'],
  },
  adminBalanceSheetManagementCorrectingEntryList: {
    name: 'adminBalanceSheetManagementCorrectingEntryList',
    fields: ['glAccount', 'offsetGlAccount'],
  },
  adminBalanceSheetManagementGLAccountList: {
    name: 'adminBalanceSheetManagementGLAccountList',
    fields: ['listName', 'glAccount'],
  },
  adminBalanceSheetManagementAccount: {
    name: 'adminBalanceSheetManagementAccount',
    fields: ['slAccount'],
  },
  adminGlAccountList: {
    name: 'adminGlAccountList',
    fields: ['listName', 'glAccount'],
  },
  adminAccountMap: {
    name: 'adminAccountMap',
    fields: ['bsmAccount', 'glAccount'],
  },
  adminChartOfAccounts: {
    name: 'adminChartOfAccounts',
    fields: ['localAccount'],
  },
  adminCustomGroups: {
    name: 'adminCustomGroups',
    fields: ['id'],
  },
  adminObligations: {
    name: 'adminObligations',
    fields: ['companyCode', 'countryCode', 'countryTaxType'],
  },
  adminCurrencyConversionRates: {
    name: 'adminCurrencyConversionRates',
    fields: ['periodName', 'fromCurrency', 'toCurrency'],
  },
  adminTrialBalanceThreshold: {
    name: 'trialBalanceThreshold',
    fields: ['functionalCurrency', 'trialBalanceThreshold'],
  },
  adminGlJournals: {
    name: 'adminGlJournals',
    fields: ['countryTaxType', 'type', 'activity', 'slAccount'],
  },
  adminCommunications: {
    name: 'adminCommunications',
    fields: ['communicationId'],
  },
  scenariosList: {
    name: 'scenariosList',
    fields: ['scenarioName'],
  },
  scenariosManageMembers: {
    name: 'scenariosManageMembers',
    fields: ['companyCode'],
  },
  scenariosManageObligations: {
    name: 'scenariosManageObligations',
    fields: ['companyCode', 'countryCode', 'countryTaxType'],
  },
  scenarioEditDetails: {
    name: 'scenarioEditDetails',
    fields: ['detailId'],
  },
};
